import {
  TopicMemberEditable,
  TopicPrivacy,
} from '../graphql/generated/graphql';
import openIcon from '../icons/open.svg';
import privateIcon from '../icons/private.svg';
import publicIcon from '../icons/public.svg';
import secretIcon from '../icons/secret.svg';
import { MEMBER_EDITABLE_NONE, MEMBER_EDITABLE_POST } from './topicPolicyCheck';

interface TopicPrivacyInfo {
  isDefault?: boolean;
  icon: string;
  label: string;
  helpText: string;
}

function getTopicPrivacyInfo(
  privacy: TopicPrivacy,
  memberEditable: TopicMemberEditable | null = TopicMemberEditable.All,
): TopicPrivacyInfo {
  let editText = '';
  if (memberEditable === MEMBER_EDITABLE_NONE) {
    editText = ' Only topic owners can edit posts.';
  } else if (memberEditable === MEMBER_EDITABLE_POST) {
    editText = ' Only topic members can edit posts.';
  }

  switch (privacy) {
    case TopicPrivacy.Open:
      return {
        isDefault: true,
        icon: openIcon,
        label: 'Open',
        helpText: `Anyone in your team can access this topic and its posts.${editText}`,
      };
    case TopicPrivacy.Public:
      return {
        icon: publicIcon,
        label: 'Public',
        helpText: `Logged out visitors can access this topic and its posts.${editText}`,
      };
    case TopicPrivacy.Private:
      return {
        icon: privateIcon,
        label: 'Private',
        helpText: `Only topic members can see posts. Anyone can request access.${editText}`,
      };
    case TopicPrivacy.Secret:
      return {
        icon: secretIcon,
        label: 'Secret',
        helpText: `Only topic members can access this topic and its posts.${editText}`,
      };
    default:
      return privacy;
  }
}

export default getTopicPrivacyInfo;

export const getPrivacyLabel = (privacy: TopicPrivacy) =>
  getTopicPrivacyInfo(privacy).label;
